import * as React from 'react';

import {Field} from 'redux-form';
// @ts-expect-error
import type {FieldProps, FieldArrayProps} from 'redux-form';

import {Button} from '../../button/button';
import {And} from '../../divider/and';
import {Line} from '../../divider/line';
import {Or} from '../../divider/or';
import {ErrorMessage} from '../../form/error-message';

import {OptionCardField} from './option-card-field';

import styles from './option-card-builder-field.module.css';

const Divider = {And, Line, Or};

export type CardData = {
    topRow: string;
    bottomRow?: string;
};

type Props<T> = {
    hideAddButton?: boolean;
    addText?: string;
    divider: 'Or' | 'And';
    cardCreator: (arg1: {
        meta: FieldProps['meta'];
        input: FieldProps['input'];
        onRemove: () => any;
    }) => any;
    getCardData: (arg1: T) => CardData;
} & FieldArrayProps;

export function OptionCardBuilderField<T>(props: Props<T>) {
    const showError = Boolean(props.meta.submitFailed && props.meta.error);
    const selected = props.fields.getAll() || [];

    const CardDivider = props.divider === 'And' ? Divider.And : Divider.Or;

    return (
        <div>
            <ul className={styles['option-card-builder-field-list']}>
                {/* @ts-expect-error */}
                {props.fields.map((item, index) => {
                    return (
                        <li key={item}>
                            {index > 0 ? <CardDivider /> : null}
                            <Field
                                name={item}
                                isCancelable={index > 0}
                                component={OptionCardField}
                                cardCreator={props.cardCreator}
                                getCardData={props.getCardData}
                                onRemove={() => {
                                    props.fields.remove(index);

                                    if (props.fields.length <= 1) {
                                        props.fields.push(null);
                                    }
                                }}
                            />
                        </li>
                    );
                })}
            </ul>
            {selected[selected.length - 1] && !props.hideAddButton ? (
                <Button variant='text-primary' onClick={() => props.fields.push(null)}>
                    {props.addText ? props.addText : '+ Add another'}
                </Button>
            ) : null}
            {showError ? (
                <div className={styles.error}>
                    <ErrorMessage>{props.meta.error}</ErrorMessage>
                </div>
            ) : null}
        </div>
    );
}
